// import React from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";

// const ApplicantDetailsModal = ({ applicant, show, onHide }) => {
//   const modalBodyStyle = {
//     padding: "1%",
//   };

//   const cardHeaderStyle = {
//     backgroundColor: "#f8f9fa",
//     borderBottom: "1px solid #dee2e6",
//   };
//   const cardStyle = {
//     marginBottom: "20px",
//   };
//   const cardBodyStyle = {
//     padding: "15px",
//     overflowY: "auto",
//   };

//   const sectionTitleStyle = {
//     fontSize: "1.2rem",
//     marginBottom: "10px",
//     color: "#007bff",
//   };

//   return (
//     <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered>
//       <Modal.Header closeButton>
//         <Modal.Title className=" gradient-text">Applicant Data</Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={modalBodyStyle}>
//         <Row className="justify-content-center">
//           <Col md={10}>
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Personal Information</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   <Col md={6}>
//                     <p>
//                       <strong>First Name:</strong> {applicant.first_name}
//                     </p>
//                     <p>
//                       <strong>Middle Name:</strong> {applicant.middle_name}
//                     </p>
//                     <p>
//                       <strong>Last Name:</strong> {applicant.last_name}
//                     </p>
//                     <p>
//                       <strong>Email:</strong> {applicant.email}
//                     </p>
//                     <p>
//                       <strong>Phone:</strong> {applicant.phone}
//                     </p>
//                     <p >
//                       <strong >Birthdate:</strong> {applicant.birthdate}
//                     </p>
//                     <p>
//                       <strong>Nationality:</strong> {applicant.nationality}
//                     </p>
//                   </Col>
//                   <Col md={6}>
//                     <p>
//                       <strong>Address Type:</strong> {applicant.address_type}
//                     </p>
//                     <p>
//                       <strong>Street Address:</strong>{" "}
//                       {applicant.street_address}
//                     </p>
//                     <p>
//                       <strong>City:</strong> {applicant.city}
//                     </p>
//                     <p>
//                       <strong>Country:</strong> {applicant.country}
//                     </p>
//                     <p>
//                       <strong>State:</strong> {applicant.state}
//                     </p>
//                     <p>
//                       <strong>Zip Code:</strong> {applicant.zip_code}
//                     </p>
//                     <p>
//                       <strong>Relocating:</strong> {applicant.relocating}
//                     </p>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>

//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Educational Details</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   <Col md={6}>
//                     <p>
//                       <strong>Degree:</strong> {applicant.degree}
//                     </p>
//                     <p>
//                       <strong>Specify Degree:</strong>{" "}
//                       {applicant.specify_degree}
//                     </p>
//                     <p>
//                       <strong>College:</strong> {applicant.college}
//                     </p>
//                     <p>
//                       <strong>Branch:</strong> {applicant.branch}
//                     </p>
//                     <p>
//                       <strong>Skills:</strong> {applicant.skills}
//                     </p>
//                   </Col>
//                   <Col md={6}>
//                     <p>
//                       <strong>Country of College:</strong>{" "}
//                       {applicant.country_of_college}
//                     </p>
//                     <p>
//                       <strong>City of College:</strong>{" "}
//                       {applicant.city_of_college}
//                     </p>
//                     <p>
//                       <strong>State of College:</strong>{" "}
//                       {applicant.state_of_college}
//                     </p>
//                     <p>
//                       <strong>Graduation Date:</strong>{" "}
//                       {applicant.graduation_date}
//                     </p>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>

//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Employment Details</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   <p>
//                     <strong>Employed with our organization:</strong>{" "}
//                     {applicant.employed_with_datetech}
//                   </p>
//                   <p>
//                     <strong>Employee ID:</strong> {applicant.employee_id}
//                   </p>
//                   <p>
//                     <strong>Employed with Government:</strong>{" "}
//                     {applicant.employed_with_govt}
//                   </p>
//                   <p>
//                     <strong>How did you hear about us:</strong>{" "}
//                     {applicant.how_did_you_hear}
//                   </p>
//                   <p>
//                     <strong>Specify how you heard:</strong>{" "}
//                     {applicant.specify_hear}
//                   </p>
//                   <p>
//                     <strong>Authorized to Work:</strong>{" "}
//                     {applicant.authorized_to_work}
//                   </p>
//                   <p>
//                     <strong>Require Visa Sponsorship:</strong>{" "}
//                     {applicant.require_visa_sponsorship}
//                   </p>
//                   <p>
//                     <strong>Employer:</strong> {applicant.employer}
//                   </p>
//                   <p>
//                     <strong>Work City:</strong> {applicant.work_city}
//                   </p>
//                   <p>
//                     <strong>Work Country:</strong> {applicant.work_country}
//                   </p>
//                   <p>
//                     <strong>Work State:</strong> {applicant.work_state}
//                   </p>
//                   <p>
//                     <strong>Job Title:</strong> {applicant.job_title}
//                   </p>
//                   <p>
//                     <strong>Work Start Date:</strong>{" "}
//                     {applicant.work_start_date}
//                   </p>
//                   <p>
//                     <strong>Work End Date:</strong> {applicant.work_end_date}
//                   </p>
//                   <p>
//                     <strong>Work Description:</strong>{" "}
//                     {applicant.work_description}
//                   </p>
//                   <p>
//                     <strong>Reason for Leaving:</strong>{" "}
//                     {applicant.reason_for_leaving}
//                   </p>
//                   <p>
//                     <strong>Current CTC:</strong> {applicant.current_ctc}
//                   </p>
//                   <p>
//                     <strong>Total Experience Months:</strong>{" "}
//                     {applicant.total_experience_months}
//                   </p>
//                   <p>
//                     <strong>Current Notice Period Days:</strong>{" "}
//                     {applicant.current_notice_period_days}
//                   </p>
//                   <p>
//                     <strong>Timezone:</strong> {applicant.timezone}
//                   </p>
//                 </Row>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onHide}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ApplicantDetailsModal;

// import React from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";

// const ApplicantDetailsModal = ({ applicant, show, onHide }) => {
//   // Basic check to ensure applicant object exists
//   if (!applicant) {
//     return null; // Or return a loading state or an empty modal
//   }

//   const modalBodyStyle = {
//     padding: "1%",
//   };

//   const cardHeaderStyle = {
//     backgroundColor: "#f8f9fa",
//     borderBottom: "1px solid #dee2e6",
//   };
//   const cardStyle = {
//     marginBottom: "20px",
//   };
//   const cardBodyStyle = {
//     padding: "15px",
//     overflowY: "auto", // Added for potentially long content
//     maxHeight: "70vh", // Limit body height if needed
//   };

//   const sectionTitleStyle = {
//     fontSize: "1.2rem",
//     marginBottom: "10px",
//     color: "#007bff",
//   };

//   const subSectionTitleStyle = {
//       fontSize: "1.0rem",
//       fontWeight: "bold",
//       marginTop: "15px",
//       marginBottom: "5px",
//       color: "#6c757d", // A slightly muted color for sub-sections
//   };


//   return (
//     <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable> {/* Added scrollable */}
//       <Modal.Header closeButton>
//         <Modal.Title className=" gradient-text">Applicant Data</Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={modalBodyStyle}>
//         <Row className="justify-content-center">
//           {/* Use Col md={11} or md={12} if more space needed within modal-xl */}
//           <Col md={11}>
//             {/* --- Personal & Address Information --- */}
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Personal & Address Information</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   {/* Personal Details */}
//                   <Col md={6}>
//                     <h6 style={subSectionTitleStyle}>Personal Details</h6>
//                     <p>
//                       <strong>First Name:</strong> {applicant.first_name || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Middle Name:</strong> {applicant.middle_name || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Last Name:</strong> {applicant.last_name || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Email:</strong> {applicant.email || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Phone:</strong> {applicant.phone || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Gender:</strong> {applicant.gender || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Date of Birth:</strong> {applicant.date_of_birth || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Age:</strong> {applicant.age !== null ? applicant.age : "N/A"}
//                     </p>
//                      <p>
//                       <strong>Employee ID:</strong> {applicant.employee_id || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Referred By:</strong> {applicant.referred_by || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Timezone:</strong> {applicant.timezone || "N/A"}
//                     </p>
//                   </Col>
//                   {/* Address Details */}
//                   <Col md={6}>
//                      <h6 style={subSectionTitleStyle}>Address Details</h6>
//                     <p>
//                       <strong>Address Type:</strong> {applicant.address_type || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Street Address:</strong>{" "}
//                       {applicant.street_address || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Village:</strong> {applicant.village || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Tehsil:</strong> {applicant.tehsil || "N/A"}
//                     </p>
//                      <p>
//                       <strong>District:</strong> {applicant.district || "N/A"}
//                     </p>
//                     <p>
//                       <strong>City:</strong> {applicant.city || "N/A"}
//                     </p>
//                     <p>
//                       <strong>State:</strong> {applicant.state || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Country:</strong> {applicant.country || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Zip Code:</strong> {applicant.zip_code !== null ? applicant.zip_code : "N/A"}
//                     </p>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>

//             {/* --- Educational Details --- */}
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Educational Details</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                  <Row>
//                     <Col md={12}> {/* General Degree */}
//                       <p>
//                         <strong>Degree Level:</strong> {applicant.degree || "N/A"}
//                       </p>
//                       <hr/>
//                     </Col>
//                  </Row>
//                 <Row>
//                   {/* Secondary Education */}
//                   <Col md={6}>
//                     <h6 style={subSectionTitleStyle}>Secondary Education (10th)</h6>
//                     <p>
//                       <strong>College/School Name:</strong> {applicant.secondary_college_name || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Field/Board:</strong> {applicant.field || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Start Date:</strong> {applicant.secondary_start_date || "N/A"}
//                     </p>
//                     <p>
//                       <strong>End Date:</strong> {applicant.secondary_end_date || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Percentage:</strong> {applicant.secondary_percentage !== null ? `${applicant.secondary_percentage}%` : "N/A"}
//                     </p>
//                   </Col>
//                   {/* Higher Secondary Education */}
//                   <Col md={6}>
//                      <h6 style={subSectionTitleStyle}>Higher Secondary Education (12th)</h6>
//                      <p>
//                       <strong>College/School Name:</strong> {applicant.higher_secondary_college_name || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Field/Stream:</strong> {applicant.higher_secondary_field || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Start Date:</strong> {applicant.higher_secondary_start_date || "N/A"}
//                     </p>
//                     <p>
//                       <strong>End Date:</strong> {applicant.higher_secondary_end_date || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Percentage:</strong> {applicant.higher_secondary_percentage !== null ? `${applicant.higher_secondary_percentage}%` : "N/A"}
//                     </p>
//                   </Col>
//                 </Row>
//                 <hr/> {/* Separator */}
//                  <Row>
//                   {/* Graduation */}
//                   <Col md={6}>
//                     <h6 style={subSectionTitleStyle}>Graduation</h6>
//                     <p>
//                       <strong>College:</strong> {applicant.graduation_college || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Branch/Major:</strong> {applicant.graduation_branch || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Start Date:</strong> {applicant.graduation_start_date || "N/A"}
//                     </p>
//                      <p>
//                       <strong>End Date:</strong> {applicant.graduation_end_date || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Percentage/CGPA:</strong> {applicant.graduation_percentage !== null ? `${applicant.graduation_percentage}%` : "N/A"} {/* Assuming % */}
//                     </p>
//                   </Col>
//                   {/* Post Graduation */}
//                   <Col md={6}>
//                      <h6 style={subSectionTitleStyle}>Post Graduation (Optional)</h6>
//                      <p>
//                       <strong>College:</strong> {applicant.post_graduate_college || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Branch/Major:</strong> {applicant.post_graduate_branch || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Start Date:</strong> {applicant.post_graduate_start_date || "N/A"}
//                     </p>
//                      <p>
//                       <strong>End Date:</strong> {applicant.post_graduate_end_date || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Percentage/CGPA:</strong> {applicant.post_graduate_percentage !== null ? `${applicant.post_graduate_percentage}%` : "N/A"} {/* Assuming % */}
//                     </p>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>

//             {/* --- Work Experience --- */}
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Work Experience</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   <Col md={6}>
//                     <p>
//                         <strong>Total Experience (Years):</strong>{" "}
//                         {applicant.Work_total_experience_year !== null ? applicant.Work_total_experience_year : "N/A"}
//                     </p>
//                      <p>
//                         <strong>Total Experience (Months):</strong>{" "}
//                         {applicant.Work_total_experience_months !== null ? applicant.Work_total_experience_months : "N/A"}
//                     </p>
//                     <p>
//                         <strong>Current Company:</strong> {applicant.current_comapny_name || "N/A"}
//                     </p>
//                     <p>
//                         <strong>Job Title:</strong> {applicant.job_title || "N/A"}
//                     </p>
//                     <p>
//                         <strong>Current Company Address:</strong>{" "}
//                         {applicant.current_company_address || "N/A"}
//                     </p>
//                      <p>
//                         <strong>Reason for Leaving:</strong>{" "}
//                         {applicant.reason_for_leaving || "N/A"}
//                      </p>

//                   </Col>
//                   <Col md={6}>
//                     <p>
//                         <strong>Current CTC:</strong> {applicant.current_ctc !== null ? applicant.current_ctc : "N/A"}
//                     </p>
//                     <p>
//                         <strong>Gross Salary:</strong> {applicant.gross !== null ? applicant.gross : "N/A"}
//                     </p>
//                     <p>
//                         <strong>Net Salary:</strong> {applicant.net !== null ? applicant.net : "N/A"}
//                     </p>
//                      <p>
//                         <strong>Variable Pay:</strong> {applicant.variables !== null ? applicant.variables : "N/A"}
//                     </p>
//                      <p>
//                         <strong>Notice Period (Days):</strong>{" "}
//                         {applicant.current_notice_period_days !== null ? applicant.current_notice_period_days : "N/A"}
//                      </p>
//                      {/* Resume link - Assuming applicant.resume contains a URL */}
//                      {applicant.resume && (
//                         <p>
//                             <strong>Resume:</strong>{" "}
//                             <a href={applicant.resume} target="_blank" rel="noopener noreferrer">View/Download</a>
//                         </p>
//                      )}
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onHide}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ApplicantDetailsModal;

// import React from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";

// const ApplicantDetailsModal = ({ applicant, show, onHide }) => {
//   // Basic check to ensure applicant object exists
//   if (!applicant) {
//     return null; // Or return a loading state or an empty modal
//   }

//   const modalBodyStyle = {
//     padding: "1%",
//   };

//   const cardHeaderStyle = {
//     backgroundColor: "#f8f9fa",
//     borderBottom: "1px solid #dee2e6",
//   };
//   const cardStyle = {
//     marginBottom: "20px",
//   };
//   const cardBodyStyle = {
//     padding: "15px",
//     overflowY: "auto", // Added for potentially long content
//     maxHeight: "70vh", // Limit body height if needed
//   };

//   const sectionTitleStyle = {
//     fontSize: "1.2rem",
//     marginBottom: "10px",
//     color: "#007bff",
//   };

//   const subSectionTitleStyle = {
//       fontSize: "1.0rem",
//       fontWeight: "bold",
//       marginTop: "15px",
//       marginBottom: "5px",
//       color: "#6c757d", // A slightly muted color for sub-sections
//   };


//   return (
//     <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable> {/* Added scrollable */}
//       <Modal.Header closeButton>
//         <Modal.Title className=" gradient-text">Applicant Data</Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={modalBodyStyle}>
//         <Row className="justify-content-center">
//           {/* Use Col md={11} or md={12} if more space needed within modal-xl */}
//           <Col md={11}>
//             {/* --- Personal & Address Information --- */}
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Personal & Address Information</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   {/* Personal Details */}
//                   <Col md={6}>
//                     <h6 style={subSectionTitleStyle}>Personal Details</h6>
//                     <p>
//                       <strong>First Name:</strong> {applicant.first_name || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Middle Name:</strong> {applicant.middle_name || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Last Name:</strong> {applicant.last_name || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Email:</strong> {applicant.email || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Phone:</strong> {applicant.phone || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Gender:</strong> {applicant.gender || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Date of Birth:</strong> {applicant.date_of_birth || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Age:</strong> {applicant.age !== null ? applicant.age : "N/A"}
//                     </p>
//                      <p>
//                       <strong>Employee ID:</strong> {applicant.employee_id || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Referred By:</strong> {applicant.referred_by || "N/A"}
//                     </p>
//                      {/* REMOVED Timezone */}
//                   </Col>
//                   {/* Address Details */}
//                   <Col md={6}>
//                      <h6 style={subSectionTitleStyle}>Address Details</h6>
//                     <p>
//                       <strong>Address Type:</strong> {applicant.address_type || "N/A"}
//                     </p>
//                     {/* REMOVED Street Address */}
//                      <p>
//                       <strong>Village:</strong> {applicant.village || "N/A"}
//                     </p>
//                      <p>
//                       <strong>Tehsil:</strong> {applicant.tehsil || "N/A"}
//                     </p>
//                      <p>
//                       <strong>District:</strong> {applicant.district || "N/A"}
//                     </p>
//                     {/* REMOVED City */}
//                     <p>
//                       <strong>State:</strong> {applicant.state || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Country:</strong> {applicant.country || "N/A"}
//                     </p>
//                     <p>
//                       <strong>Zip Code:</strong> {applicant.zip_code !== null ? applicant.zip_code : "N/A"}
//                     </p>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>

//             {/* --- Educational Details --- */}
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Educational Details</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                  <Row>
//                     <Col md={6}> {/* General Education */}
//                       <h6 style={subSectionTitleStyle}>General Education</h6>
//                       <p>
//                         <strong>Degree Level:</strong> {applicant.degree || "N/A"}
//                       </p>
//                       <p>
//                         {/* Displaying the 'education' TextField */}
//                         <strong>Education Summary:</strong> {applicant.education || "N/A"}
//                       </p>
//                     </Col>
//                     {/* Removed detailed Secondary, Higher Secondary, Graduation, Post-Graduation sections */}
//                  </Row>
//               </Card.Body>
//             </Card>

//             {/* --- Work Experience --- */}
//             <Card style={cardStyle}>
//               <Card.Header style={cardHeaderStyle}>
//                 <h5 style={sectionTitleStyle}>Work Experience</h5>
//               </Card.Header>
//               <Card.Body style={cardBodyStyle}>
//                 <Row>
//                   <Col md={6}>
//                     <h6 style={subSectionTitleStyle}>Experience Overview</h6>
//                     <p>
//                         <strong>Total Experience (Years):</strong>{" "}
//                         {applicant.Work_total_experience_year !== null ? applicant.Work_total_experience_year : "N/A"}
//                     </p>
//                      <p>
//                         <strong>Total Experience (Months):</strong>{" "}
//                         {applicant.Work_total_experience_months !== null ? applicant.Work_total_experience_months : "N/A"}
//                     </p>
//                      <p>
//                         {/* Displaying the 'experience' TextField */}
//                         <strong>Experience Summary:</strong>{" "}
//                         {applicant.experience || "N/A"}
//                     </p>
//                     <hr/>
//                     <h6 style={subSectionTitleStyle}>Current Role</h6>
//                     <p>
//                         {/* Kept typo to match model */}
//                         <strong>Current Company:</strong> {applicant.current_comapny_name || "N/A"}
//                     </p>
//                     <p>
//                         <strong>Job Title:</strong> {applicant.job_title || "N/A"}
//                     </p>
//                     <p>
//                         <strong>Current Company Address:</strong>{" "}
//                         {applicant.current_company_address || "N/A"}
//                     </p>
//                      <p>
//                         <strong>Reason for Leaving:</strong>{" "}
//                         {applicant.reason_for_leaving || "N/A"}
//                      </p>

//                   </Col>
//                   <Col md={6}>
//                      <h6 style={subSectionTitleStyle}>Compensation & Logistics</h6>
//                     <p>
//                         <strong>Current CTC:</strong> {applicant.current_ctc !== null ? applicant.current_ctc : "N/A"}
//                     </p>
//                     <p>
//                         <strong>Gross Salary:</strong> {applicant.gross !== null ? applicant.gross : "N/A"}
//                     </p>
//                     <p>
//                         <strong>Net Salary:</strong> {applicant.net !== null ? applicant.net : "N/A"}
//                     </p>
//                      <p>
//                         <strong>Variable Pay:</strong> {applicant.variables !== null ? applicant.variables : "N/A"}
//                     </p>
//                      <p>
//                         <strong>Notice Period (Days):</strong>{" "}
//                         {applicant.current_notice_period_days !== null ? applicant.current_notice_period_days : "N/A"}
//                      </p>
//                      {/* Resume link - Assuming applicant.resume contains a URL */}
//                      {applicant.resume && (
//                         <p style={{marginTop: "15px"}}> {/* Added margin top for spacing */}
//                             <strong>Resume:</strong>{" "}
//                             <a href={applicant.resume} target="_blank" rel="noopener noreferrer">View/Download</a>
//                         </p>
//                      )}
//                   </Col>
//                 </Row>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onHide}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default ApplicantDetailsModal;


import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Form, Button, Row, Col, Card, Container } from "react-bootstrap";
// You might need to import your Sidebar and Navbar components here as well
// import Navbar from "../Misc/Navbar";
// import Sidebar from "../Misc/Sidebar";

// This component contains the form and the logic to create/update a profile
export default function CreateProfile() {
  const [formData, setFormData] = useState({
    // Personal Details
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    phone: "",
    gender: "",
    date_of_birth: "",
    age: "",
    employee_id: "",
    referred_by: "",
    // Address Details
    address_type: "",
    village: "",
    tehsil: "",
    district: "",
    state: "",
    country: "",
    zip_code: "",
    // Educational Details
    degree: "",
    education: "", // Summary field
    // Work Experience
    Work_total_experience_year: "",
    Work_total_experience_months: "",
    experience: "", // Summary field
    // Current Role
    current_comapny_name: "",
    job_title: "",
    current_company_address: "",
    reason_for_leaving: "",
    // Compensation & Logistics
    current_ctc: "",
    gross: "",
    net: "",
    variables: "",
    current_notice_period_days: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true); // To show a loader while fetching initial data

  // Fetch existing applicant data when the component loads
  useEffect(() => {
    const fetchApplicantData = async () => {
      const userId = localStorage.getItem("user_id");
      if (!userId) {
        Swal.fire("Error", "Could not find user ID. Please log in again.", "error");
        setIsFetching(false);
        return;
      }

      try {
        // IMPORTANT: Use the correct GET endpoint to fetch a user's data
        const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/get_applicant_details/${userId}/`);
        // Pre-fill the form with existing data, ensuring nulls become empty strings
        const data = response.data;
        const formattedData = {};
        for (const key in formData) {
            formattedData[key] = data[key] || "";
        }
        setFormData(formattedData);
      } catch (error) {
        // It's okay if this fails (e.g., 404 for a new user), it just means the form will be empty
        console.log("No existing profile data found for this user, which is normal for new users.");
      } finally {
        setIsFetching(false);
      }
    };

    fetchApplicantData();
  }, []); // Empty dependency array means this runs only once on mount

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // --- THE CRUCIAL FIX IS HERE ---
    // 1. Get the user_id from localStorage.
    const userId = localStorage.getItem("user_id");

    if (!userId) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "Your session has expired or you are not logged in. Please log in again.",
      });
      setLoading(false);
      return;
    }

    // 2. Create a payload object with all form data AND the user_id.
    // The backend needs the user_id to know which applicant to find and update.
    const payload = {
      ...formData,
      user_id: userId,
    };

    try {
      // 3. Send the complete payload to the update endpoint.
      // Make sure this URL is correct. Use POST for creation/update.
      const response = await axios.post("https://raasbackend.vetrinahealthcare.com/update_applicant/", payload);

      Swal.fire({
        icon: "success",
        title: "Profile Updated!",
        text: response.data.message || "Your profile has been saved successfully.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      // This will now display the backend's error message, like "Applicant not found" if the ID is wrong
      const errorMessage = error.response?.data?.error || "An unknown error occurred while updating your profile.";
      Swal.fire({
        icon: "error",
        title: "Update Failed!",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };
  
  if (isFetching) {
    return <div>Loading Profile...</div>; // Or a spinner component
  }

  return (
    <Container fluid>
      {/* You would have your Navbar and Sidebar components here */}
      <Row>
        {/* <Col md={2}><Sidebar /></Col> */}
        <Col>
          <div className="profile-management-page">
            <h2 className="mb-4">Profile Management</h2>
            <p className="text-muted">Fields marked with * are required.</p>

            <Form onSubmit={handleSubmit}>
              {/* Personal Information Card */}
              <Card className="mb-4">
                <Card.Header as="h5">Personal & Address Information</Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>First Name *</Form.Label>
                        <Form.Control type="text" name="first_name" value={formData.first_name} onChange={handleInputChange} required />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Middle Name</Form.Label>
                        <Form.Control type="text" name="middle_name" value={formData.middle_name} onChange={handleInputChange} />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Last Name *</Form.Label>
                        <Form.Control type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} required />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                     <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" name="email" value={formData.email} onChange={handleInputChange} />
                      </Form.Group>
                    </Col>
                     <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control type="tel" name="phone" value={formData.phone} onChange={handleInputChange} />
                      </Form.Group>
                    </Col>
                  </Row>
                   {/* Add other personal fields like gender, dob, etc. similarly */}
                </Card.Body>
              </Card>

              {/* Educational Details Card */}
              <Card className="mb-4">
                <Card.Header as="h5">Educational Details</Card.Header>
                <Card.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Highest Degree Level</Form.Label>
                        <Form.Control type="text" name="degree" placeholder="e.g., Bachelor of Science" value={formData.degree} onChange={handleInputChange} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Education Summary</Form.Label>
                        <Form.Control as="textarea" rows={4} name="education" placeholder="Provide a summary of your educational background, key institutions, and achievements." value={formData.education} onChange={handleInputChange} />
                    </Form.Group>
                </Card.Body>
              </Card>

              {/* Work Experience Card */}
               <Card className="mb-4">
                <Card.Header as="h5">Work Experience</Card.Header>
                <Card.Body>
                  <Row>
                     <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Total Experience (Years)</Form.Label>
                            <Form.Control type="number" name="Work_total_experience_year" value={formData.Work_total_experience_year} onChange={handleInputChange} />
                        </Form.Group>
                     </Col>
                     <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Total Experience (Months)</Form.Label>
                            <Form.Control type="number" name="Work_total_experience_months" value={formData.Work_total_experience_months} onChange={handleInputChange} />
                        </Form.Group>
                     </Col>
                  </Row>
                  <Form.Group className="mb-3">
                        <Form.Label>Experience Summary</Form.Label>
                        <Form.Control as="textarea" rows={5} name="experience" placeholder="Describe your professional roles, responsibilities, and key accomplishments." value={formData.experience} onChange={handleInputChange} />
                  </Form.Group>
                   {/* Add other experience fields here */}
                </Card.Body>
              </Card>

              <div className="text-end">
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? 'Saving...' : 'Save Profile'}
                </Button>
              </div>

            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}